// extracted by mini-css-extract-plugin
export default {"productGrid":"SZ-z","centerLink":"TZ-z","productSection":"UZ-z","item":"VZ-z","ctaButton":"WZ-z"};